import { render, staticRenderFns } from "./double.vue?vue&type=template&id=58dbef6d&scoped=true"
import script from "./double.vue?vue&type=script&lang=ts"
export * from "./double.vue?vue&type=script&lang=ts"
import style0 from "./double.vue?vue&type=style&index=0&id=58dbef6d&prod&scoped=true&lang=css"
import style1 from "./double.vue?vue&type=style&index=1&id=58dbef6d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dbef6d",
  null
  
)

export default component.exports